import React from 'react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { PetInterface } from 'types/pet';
import { contactPath, emailUsPath } from '../../../util/config';
import { getErrorPageCopy } from '../copy';

import './manage-pet-error-page.scss';

export type ManagePetErrorPageProps = {
  pet: PetInterface;
};

export const ManagePetErrorPage = ({ pet }: ManagePetErrorPageProps) => {
  const classNamePrefix = `manage-pet-error`;

  const {
    headerText,
    bodyText,
    contactButtonText,
    callButtonText,
    phoneNumber,
    emailButtonText,
  } = getErrorPageCopy(pet);

  return (
    <div className={`${classNamePrefix}`}>
      <p className={`${classNamePrefix}__header`} data-testid={`${classNamePrefix}__header`}>
        {headerText}
      </p>
      <p className={`${classNamePrefix}__body`} data-testid={`${classNamePrefix}__body`}>
        {bodyText}
      </p>
      <div className={`${classNamePrefix}__desktop-actions`}>
        <KibButtonNew
          className={`${classNamePrefix}__contact-button`}
          data-testid={`${classNamePrefix}__contact-button`}
          emphasis="primary"
          size="large"
          href={contactPath}
          target="_blank"
          rel="noreferrer"
        >
          {contactButtonText}
        </KibButtonNew>
      </div>
      <div className={`${classNamePrefix}__mobile-actions`}>
        <KibButtonNew
          className={`${classNamePrefix}__call-button`}
          data-testid={`${classNamePrefix}__call-button`}
          emphasis="primary"
          size="large"
          href={phoneNumber}
        >
          {callButtonText}
        </KibButtonNew>
        <KibButtonNew
          className={`${classNamePrefix}__email-button`}
          data-testid={`${classNamePrefix}__email-button`}
          emphasis="tertiary"
          size="large"
          href={emailUsPath}
          target="_blank"
          rel="noreferrer"
        >
          {emailButtonText}
        </KibButtonNew>
      </div>
    </div>
  );
};
